var _path, _rect, _path2, _line, _line2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPnidsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34315 1.34315 0 3 0H29C30.6569 0 32 1.34315 32 3V29C32 30.6569 30.6569 32 29 32H3C1.34315 32 0 30.6569 0 29V3Z",
    fill: "#FFEAF2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7,
    width: 22,
    height: 18,
    fill: "white",
    stroke: "#333333",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0347 13.1805C15.1348 13.1805 14.4053 13.91 14.4053 14.8099V17.8483C14.4353 18.7215 15.153 19.4204 16.0337 19.4204C16.9336 19.4204 17.6631 18.6909 17.6631 17.791H17.6641V14.8099C17.6641 13.91 16.9346 13.1805 16.0347 13.1805ZM18.6623 17.8566H18.6641V14.8099C18.6641 13.3577 17.4869 12.1805 16.0347 12.1805C14.5825 12.1805 13.4053 13.3577 13.4053 14.8099V17.791H13.4043C13.4043 17.8179 13.4047 17.8447 13.4055 17.8714C13.4481 19.2865 14.6084 20.4204 16.0337 20.4204C17.464 20.4204 18.6275 19.2784 18.6623 17.8566Z",
    fill: "#333333"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.0332,
    y1: 16.1843,
    x2: 13.6521,
    y2: 16.1843,
    stroke: "#333333"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 19.334,
    y1: 13.254,
    x2: 19.334,
    y2: 13.2338,
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.614 16.3005H22.3437V20.4204H26.2715",
    stroke: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20.1831L16 24.2404",
    stroke: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53711 7.74319L8.53711 15.7105",
    stroke: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPnidsIcon);
export default __webpack_public_path__ + "static/media/pnidsIcon.d88f18621243b79995f0892d5363f7a9.svg";
export { ForwardRef as ReactComponent };